const Sponsors = () => {
  return (
    <div className="bg-gray-100 flex justify-center py-20">
      <img src="assets/Sponsors.png" alt="sponsors" />
    </div>
  );
};

export default Sponsors;
